import { HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import workflowMock from '../../../mocks/workflow-mock.json';

/**
 * Interceptor to mock workflow API calls
 * Intercepts GET requests to /v1.0/order/{orderId}/workflow
 *
 * To enable/disable: Set WORKFLOW_MOCK_ENABLED in environment or toggle below
 */

const MOCK_ENABLED = false; // Set to false to disable mocking
const MOCK_DELAY = 500; // Simulate network delay (ms)

export function workflowMockInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  // Only intercept if mocking is enabled
  if (!MOCK_ENABLED) {
    return next(req);
  }

  // Check if this is a workflow API call
  // Pattern: /v1.0/order/{orderId}/workflow
  const workflowPattern = /\/v1\.0\/order\/[^/]+\/workflow$/;

  if (req.method === 'GET' && workflowPattern.test(req.url)) {
    console.log('🔧 [Mock Interceptor] Intercepting workflow API call:', req.url);
    console.log('🔧 [Mock Interceptor] Returning mock workflow data');

    // Return mock workflow data
    return of(
      new HttpResponse({
        status: 200,
        body: workflowMock,
      })
    ).pipe(delay(MOCK_DELAY));
  }

  // Pass through all other requests
  return next(req);
}
